import { keepPreviousData, useQuery } from "@tanstack/react-query";
import View from "views/logic/views/View";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import PaginationURL from "util/PaginationURL";
import { defaultOnError } from "util/conditional/onError";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const KEY_PREFIX = ["dashboards", "overview"];
export const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
const dashboardsUrl = qualifyUrl("/dashboards");
export const fetchDashboards = (searchParams) => {
  const url = PaginationURL(dashboardsUrl, searchParams.page, searchParams.pageSize, searchParams.query, {
    sort: searchParams.sort.attributeId,
    order: searchParams.sort.direction,
    scope: searchParams.scope,
    filters: FiltersForQueryParams(searchParams.filters)
  });
  return fetch("GET", qualifyUrl(url)).then(
    ({ elements, total, count, page, per_page: perPage, attributes }) => ({
      list: elements.map((item) => View.fromJSON(item)),
      pagination: { total, count, page, perPage },
      attributes
    })
  );
};
const useDashboards = (searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchDashboards(searchParams),
      "Loading dashboards failed with status",
      "Could not load dashboards"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isInitialLoading
  };
};
export default useDashboards;
